import { render, staticRenderFns } from "./TypesMenu.vue?vue&type=template&id=8ec50d22&scoped=true&lang=html&"
import script from "./TypesMenu.vue?vue&type=script&lang=js&"
export * from "./TypesMenu.vue?vue&type=script&lang=js&"
import style0 from "./TypesMenu.vue?vue&type=style&index=0&id=8ec50d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec50d22",
  null
  
)

export default component.exports